/*
** Parses env variables provided in django base template.
** Handling them at runtime instead of build-time allows us
** to keep the same docker image in all environments
** (local, staging, production).
*/

interface Env {
  IRCAM_AUTH_URL: string
  FORUM_ASSETS_URL: string
  SENTRY_ENV: string
  authenticated: boolean
}

class EnvironmentError extends Error {}

function isURL (input: string): boolean {
  try {
    // eslint-disable-next-line no-new
    new URL(input)
    return true
  } catch (e) {
    return false
  }
}

const element = document.getElementById('environment')
if (element === null) {
  throw new EnvironmentError('missing <script id="environment"></script>')
}
let env
try {
  env = JSON.parse(element.textContent ?? '')
} catch (error) {
  throw new EnvironmentError('unable to parse environment as JSON')
}

// validate variables
const { IRCAM_AUTH_URL, FORUM_ASSETS_URL, SENTRY_ENV, authenticated } = env as Env
if (typeof IRCAM_AUTH_URL !== 'string' || !isURL(IRCAM_AUTH_URL)) {
  throw new EnvironmentError('invalid IRCAM_AUTH_URL')
}
if (typeof FORUM_ASSETS_URL !== 'string' || !isURL(FORUM_ASSETS_URL)) {
  throw new EnvironmentError('invalid FORUM_ASSETS_URL')
}
if (typeof SENTRY_ENV !== 'string' || SENTRY_ENV === '') {
  throw new EnvironmentError('invalid SENTRY_ENV')
}
if (typeof authenticated !== 'boolean') {
  throw new EnvironmentError('invalid authenticated')
}

export {
  IRCAM_AUTH_URL,
  FORUM_ASSETS_URL,
  SENTRY_ENV,
  authenticated
}
